export const getImageSrc = (url) => {
    return `${process.env.NEXT_PUBLIC_SERVER_URL}${url}`;
};
